import { ProductCategory } from "../context/ShoppingCartContext";

export function getCategoryChildren(
  category: ProductCategory
): ProductCategory[] {
  return category.children ?? category.cashregisterChildren ?? [];
}

export function categoryContainsDescendant(
  category: ProductCategory,
  uuid: string
): boolean {
  return getCategoryChildren(category).some(
    (child) => child.uuid === uuid || categoryContainsDescendant(child, uuid)
  );
}

export function normalizeProductCategoryTree(
  categories: ProductCategory[]
): ProductCategory[] {
  return categories.map((category) => {
    const children = getCategoryChildren(category);
    const { cashregisterChildren: _legacy, children: _children, ...rest } =
      category;
    return {
      ...rest,
      children: normalizeProductCategoryTree(children),
    };
  });
}
